import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Modal, useModals } from 'almanac-ui/Modal'

export const TranscribedTextModal = ({ content }: { content: string }) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root centered={false} onPressOutside={closeModal} size="md">
      <Modal.Header>
        <Heading level={3}>Transcribed Text</Heading>
      </Modal.Header>
      <Modal.Content>
        <Text color={'var(--dark-80)'} variant="placeholder">
          {content}
        </Text>
      </Modal.Content>
      <Modal.Footer></Modal.Footer>
    </Modal.Root>
  )
}
